import React, { useEffect, useState } from 'react';
import { postIndecxCsat } from '~/services/commitmentService';
import { LoadingOverlay } from './styles';
import Loading from '~/components/layout/Loading';

const INDECX_SCRIPT_ID = 'script-indecx';
const INDECX_WIDGET_URL =
  'https://indecx-widget.s3.amazonaws.com/widget-production-v3.js';
const INDECX_KEY = '5e46926028a0ef00ed5fc759';
const INDECX_ACTION = '698396eaecd946002075494e';

const getCsatPayload = (commitmentId, consultantName) => {
  const codeStore = localStorage.getItem('codeStore') || '';
  const parts = codeStore.split('-');
  const codigoDeCliente = (parts[0] || '').trim();
  const codigoDeEndereco = (parts[1] || '').trim();

  return {
    nome: localStorage.getItem('userName') || '',
    email: localStorage.getItem('email') || '',
    telefone:
      localStorage.getItem('userPhone') ||
      localStorage.getItem('consultantPhone') ||
      '',
    codigo_de_cliente: codigoDeCliente,
    codigo_de_endereco: codigoDeEndereco,
    mercado: localStorage.getItem('market') || '',
    Tipo: 'Vendas',
    nucleo: localStorage.getItem('core') || '',
    atendimento_comercial: 'Presencial',
    proprietarioconta:
      consultantName || localStorage.getItem('consultantName') || '',
    WhatId: commitmentId || '',
    Negocio: 'Domiciliar',
  };
};

const MOBILE_BREAKPOINT = 768;

const getIndecxDimensions = () => {
  if (typeof window === 'undefined') return { width: 700, height: 650 };
  const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
  if (isMobile) {
    return {
      width: Math.min(window.innerWidth - 32, 360),
      height: Math.min(Math.floor(window.innerHeight * 0.85), 600),
    };
  }
  return { width: 710, height: 680 };
};

const getIndecxConfig = (commitmentId, consultantName) => {
  const codeStore = localStorage.getItem('codeStore') || '';
  const parts = codeStore.split('-');
  const codigoDeCliente = (parts[0] || '').trim();
  const codigoDeEndereco = (parts[1] || '').trim();
  const { width, height } = getIndecxDimensions();

  return {
    key: INDECX_KEY,
    action: INDECX_ACTION,
    width,
    height,
    name: localStorage.getItem('userName') || '',
    email: localStorage.getItem('email') || '',
    phone:
      localStorage.getItem('userPhone') ||
      localStorage.getItem('consultantPhone') ||
      '',
    indicators: {
      codigo_de_cliente: codigoDeCliente,
      codigo_de_endereco: codigoDeEndereco,
      mercado: localStorage.getItem('market') || '',
      nucleo: localStorage.getItem('core') || '',
      atendimento_comercial: 'Presencial',
      proprietarioconta:
        consultantName || localStorage.getItem('consultantName') || '',
      WhatId: commitmentId || '',
      Negocio: 'Domiciliar',
    },
  };
};

const runIndecx = config => {
  try {
    if (typeof window.IndeCX === 'function') {
      window.IndeCX(config);
    }
  } catch (e) {
    console.warn('IndeCX init error', e);
  }
};

const injectIndecxScript = config => {
  if (document.getElementById(INDECX_SCRIPT_ID)) {
    runIndecx(config);
    return;
  }

  const script = document.createElement('script');
  script.id = INDECX_SCRIPT_ID;
  script.src = INDECX_WIDGET_URL;
  script.type = 'text/javascript';
  script.async = true;
  script.onload = script.onreadystatechange = function () {
    const readyState = this.readyState;
    if (readyState && readyState !== 'complete' && readyState !== 'loaded')
      return;
    runIndecx(config);
  };
  document.body.appendChild(script);
};

const INDECX_WIDGET_ID = 'indecx-widget';
const POLL_INTERVAL_MS = 150;
const MAX_WAIT_MS = 5000;

const isWidgetVisible = () => {
  const el = document.getElementById(INDECX_WIDGET_ID);
  return el && el.style.display === 'block';
};

const ConsultantRatingModal = ({
  isOpen,
  onClose,
  onSurveyDisabled,
  onWidgetClose,
  commitmentId,
  consultantName,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || typeof onClose !== 'function') return;

    setIsLoading(true);

    const baseConfig = getIndecxConfig(commitmentId, consultantName);
    const csatPayload = getCsatPayload(commitmentId, consultantName);

    let pollIntervalId;
    let maxTimeoutId;

    const finishLoading = () => {
      if (pollIntervalId) clearInterval(pollIntervalId);
      if (maxTimeoutId) clearTimeout(maxTimeoutId);
      setIsLoading(false);
      if (typeof onClose === 'function') {
        onClose();
      }
    };

    const handleSurveyDisabled = () => {
      if (pollIntervalId) clearInterval(pollIntervalId);
      if (maxTimeoutId) clearTimeout(maxTimeoutId);
      if (typeof onSurveyDisabled === 'function') {
        onSurveyDisabled();
      }
    };

    const config = {
      ...baseConfig,
      onSuccess: () => {
        if (pollIntervalId) clearInterval(pollIntervalId);
        if (maxTimeoutId) clearTimeout(maxTimeoutId);
        if (typeof onSurveyDisabled === 'function') {
          onSurveyDisabled();
        }
      },
      onError: () => {
        handleSurveyDisabled();
      },
      onModalClose: () => {
        if (typeof onWidgetClose === 'function') {
          onWidgetClose();
        }
      },
    };

    injectIndecxScript(config);
    postIndecxCsat(csatPayload);

    pollIntervalId = setInterval(() => {
      if (isWidgetVisible()) {
        finishLoading();
      }
    }, POLL_INTERVAL_MS);

    maxTimeoutId = setTimeout(finishLoading, MAX_WAIT_MS);

    return () => {
      if (pollIntervalId) clearInterval(pollIntervalId);
      if (maxTimeoutId) clearTimeout(maxTimeoutId);
    };
  }, [isOpen, commitmentId, consultantName, onClose, onSurveyDisabled, onWidgetClose]);

  if (!isOpen) return null;

  return (
    <>
      {isLoading && (
        <LoadingOverlay>
          <Loading />
        </LoadingOverlay>
      )}
    </>
  );
};

export default ConsultantRatingModal;
